import React from "react";

import styles from "./NormalInput.module.scss";

const NormalInput = ({
  label,
  value = "",
  max = null,
  type = "text",
  register = null,
  error = false,
  placeholder = "Enter Here",
  disabled = false,
  readOnly = false,
  color = "black",
  onChange = () => ({}),
  onkeydown,
}) => {
  return (
    <div
      className={`${styles.normal_input} ${readOnly ? styles.readonly : ""}`}
    >
      <label>{label}</label>
      {disabled ? (
        <span style={{ color: color }}>{value}</span>
      ) : (
        <input
          {...register}
          type={type}
          max={max}
          defaultValue={value}
          placeholder={placeholder}
          style={{ borderColor: error ? "#f90500" : "#c4c4c4" }}
          disabled={readOnly}
          onChange={(e) => {
            let body = {};
            body = {
              name: register.name,
              value: e.target.value,
            };
            onChange(body);
          }}
          onKeyDown={onkeydown}
        />
      )}
    </div>
  );
};

export default NormalInput;
